'use client';

import useRouteTracker from 'src/services/useRouteTracker';

const History = () => {
  useRouteTracker();

  return null;
};

export default History;
